import React, { useState, useEffect } from "react";

const VerifyEmail = () => {
  const [otp, setOtp] = useState("");
  const [resendDisabled, setResendDisabled] = useState(false);
  const [countdown, setCountdown] = useState(60);

  useEffect(() => {
    let timer;

    if (resendDisabled && countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [resendDisabled, countdown]);

  const handleOtpSubmit = (e) => {
    e.preventDefault();
    // OTP submission logic placeholder
  };

  const handleResendEmail = () => {
    // Add your logic to resend the email
    setResendDisabled(true);

    // Start the countdown timer
    setCountdown(60);

    setTimeout(() => {
      setResendDisabled(false);
    }, 60000);
  };

  return (
    <div className="max-w-md mx-auto  mt-8 p-6 bg-white shadow-md rounded-md">
      <h2 className="text-2xl font-bold mb-4">Enter OTP Sent to your email</h2>
      <form onSubmit={handleOtpSubmit}>
        <div className="mb-4">
          <input
            type="text"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            className="w-full p-2 border rounded-md"
            required
          />
        </div>
        <div className="mb-4">
          <button
            type="submit"
            className="bg-blue-500 text-white px-4 py-2 rounded-md"
          >
            Submit
          </button>
        </div>
      </form>
      <p className="text-sm">
        Resend OTP in {countdown} seconds
        <button
          onClick={handleResendEmail}
          disabled={resendDisabled}
          className="text-blue-500 underline ml-1"
        >
          Resend
        </button>
      </p>
    </div>
  );
};

export default VerifyEmail;
